const $blockForms = $('.form-block form');
const $ctaForms = $('.cta-cards form');

if($blockForms.length > 0) {
  setConsentLink($blockForms);
}

if($ctaForms.length > 0) {
  setConsentLink($ctaForms);
}

if($blockForms.length > 0 || $ctaForms.length > 0) {
  fillField('gclid', getUrlParam('gclid'));
  fillField('fbclid', getUrlParam('fbclid'));
}

function setConsentLink($forms) {
  $forms.each(function() {
    if($(this).find('input[data-name="privacy_policy"]').length > 0 && $(this).find('input[data-name="privacy_policy"] + span label').length > 0) {
      let $text = $(this).find('input[data-name="privacy_policy"] + span label').text();
      $text = $text.replace('Integritetspolicy', '<a href="https://upheads.se/upheads-integritets-och-persondatapolicy" target="_blank">Integritetspolicy</a> ');
      $(this).find('input[data-name="privacy_policy"] + span label').html($text);
    }
  });
}

function getUrlParam(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name) || '';
}

function fillField(fieldName, value) {
  const fields = document.querySelectorAll(
    `input[name="${fieldName}"], input[id="${fieldName}"]`
  );
  if (fields.length === 0 || !value) return; // exit if field doesn't exist or no value
  fields.forEach(el => el.value = value);
}